'use strict';
var parent = require('../../es/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/stable/array/from.js
// module id = 1553
// module chunks = 0